var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuroMuseLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.62,3.51v64.97H3.66V3.51h64.96ZM65.84,6.29H6.44v59.42h59.41V6.29Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.79,
    y: 9.07,
    width: 5.55,
    height: 54.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.21,
    y: 9.07,
    width: 5.27,
    height: 54.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.37,
    y: 19.9,
    width: 5.55,
    height: 32.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.32,
    y: 14.34,
    width: 5.27,
    height: 29.99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.69,
    y: 27.95,
    width: 5.27,
    height: 29.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.74,
    y: 33.22,
    width: 5.27,
    height: 27.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.27,
    y: 11.84,
    width: 5.27,
    height: 26.93
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuroMuseLogoNoText);
export default __webpack_public_path__ + "static/media/NeuroMuse_Logo_NoText.df29618f74c25f3e9c778946018efdf2.svg";
export { ForwardRef as ReactComponent };